import React from 'react';
import { MapPin, Phone, Mail, X } from 'lucide-react';
import type { TravelAgency } from '../types';
import { getImageUrl } from '../utils/imageUrl';
import { getAgencyPageUrl } from '../utils/agencyPageUrl';

interface NearbyAgenciesModalProps {
  isOpen: boolean;
  onClose: () => void;
  agencies: TravelAgency[];
}

export default function NearbyAgenciesModal({ isOpen, onClose, agencies }: NearbyAgenciesModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            {/*<h2 className="text-2xl font-bold">Agences partenaires près de chez vous</h2>*/}
            <h2 className="text-2xl font-bold">Prochainement disponible</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="space-y-6">
            {agencies.map((agency) => (
              <div key={agency.id} className="border rounded-lg p-4 hover:border-blue-500 transition-colors">
                <div className="flex items-center gap-4 mb-4">
                  <img src={getImageUrl(agency.logo)} alt={agency.name} className="w-16 h-16 rounded-full object-cover" />
                  <div>
                    <h3 className="text-lg font-semibold">{agency.name}</h3>
                    <div className="flex items-center text-sm text-gray-600">
                      <MapPin className="w-4 h-4 mr-1" />
                      <span>2.5 km de votre position</span>
                    </div>
                  </div>
                </div>

                <div className="space-y-2 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <MapPin className="w-4 h-4" />
                    <span>123 Avenue des Voyages, 75001 Paris</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Phone className="w-4 h-4" />
                    <span>01 23 45 67 89</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Mail className="w-4 h-4" />
                    <span>contact@{agency.id}.fr</span>
                  </div>
                </div>

                <div className="mt-4 flex justify-end">
                  <a
                    href={getAgencyPageUrl(agency)}
                    className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                  >
                    Voir l'agence
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}